import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CondensedWithMenu from './CondensedWithMenu';
import ClientProvider from './client';
export default createDemo(import.meta.url, CondensedWithMenu, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/breadcrumbs/demos/condensed-with-menu/CondensedWithMenu.tsx",
    "fileName": "CondensedWithMenu.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Breadcrumbs from '@mui/material/Breadcrumbs';\nimport Link from '@mui/material/Link';\nimport Menu from '@mui/material/Menu';\nimport MenuItem from '@mui/material/MenuItem';\nimport IconButton from '@mui/material/IconButton';\nimport MoreHorizIcon from '@mui/icons-material/MoreHoriz';\n\nexport default function CondensedWithMenu() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);\n  const open = Boolean(anchorEl);\n\n  const handleClick = (event: React.MouseEvent<HTMLButtonElement> | null) => {\n    if (event) {\n      setAnchorEl(event.currentTarget);\n    }\n  };\n\n  const handleClose = () => {\n    setAnchorEl(null);\n  };\n\n  return (\n    <React.Fragment>\n      <Menu\n        anchorEl={anchorEl}\n        open={open}\n        onClose={handleClose}\n        aria-labelledby=\"with-menu-demo-breadcrumbs\"\n      >\n        <MenuItem onClick={handleClose}>Breadcrumb 2</MenuItem>\n        <MenuItem onClick={handleClose}>Breadcrumb 3</MenuItem>\n        <MenuItem onClick={handleClose}>Breadcrumb 4</MenuItem>\n      </Menu>\n      <Breadcrumbs aria-label=\"breadcrumbs\">\n        <Link color=\"primary\" href=\"#condensed-with-menu\">\n          Breadcrumb 1\n        </Link>\n        <IconButton color=\"primary\" size=\"small\" onClick={handleClick}>\n          <MoreHorizIcon />\n        </IconButton>\n        <Link color=\"primary\" href=\"#condensed-with-menu\">\n          Breadcrumb 5\n        </Link>\n        <Link color=\"primary\" href=\"#condensed-with-menu\">\n          Breadcrumb 6\n        </Link>\n      </Breadcrumbs>\n    </React.Fragment>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 51,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Breadcrumbs from '@mui/material/Breadcrumbs';\nimport Link from '@mui/material/Link';\nimport Menu from '@mui/material/Menu';\nimport MenuItem from '@mui/material/MenuItem';\nimport IconButton from '@mui/material/IconButton';\nimport MoreHorizIcon from '@mui/icons-material/MoreHoriz';\n\nexport default function CondensedWithMenu() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);\n  const open = Boolean(anchorEl);\n\n  const handleClick = (event: React.MouseEvent<HTMLButtonElement> | null) => {\n    if (event) {\n      setAnchorEl(event.currentTarget);\n    }\n  };\n\n  const handleClose = () => {\n    setAnchorEl(null);\n  };\n\n  return (\n    <React.Fragment>\n      <Menu\n        anchorEl={anchorEl}\n        open={open}\n        onClose={handleClose}\n        aria-labelledby=\"with-menu-demo-breadcrumbs\"\n      >\n        <MenuItem onClick={handleClose}>Breadcrumb 2</MenuItem>\n        <MenuItem onClick={handleClose}>Breadcrumb 3</MenuItem>\n        <MenuItem onClick={handleClose}>Breadcrumb 4</MenuItem>\n      </Menu>\n      <Breadcrumbs aria-label=\"breadcrumbs\">\n        <Link color=\"primary\" href=\"#condensed-with-menu\">\n          Breadcrumb 1\n        </Link>\n        <IconButton color=\"primary\" size=\"small\" onClick={handleClick}>\n          <MoreHorizIcon />\n        </IconButton>\n        <Link color=\"primary\" href=\"#condensed-with-menu\">\n          Breadcrumb 5\n        </Link>\n        <Link color=\"primary\" href=\"#condensed-with-menu\">\n          Breadcrumb 6\n        </Link>\n      </Breadcrumbs>\n    </React.Fragment>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 51,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Breadcrumbs",
      "@mui/material/Link",
      "@mui/material/Menu",
      "@mui/material/MenuItem",
      "@mui/material/IconButton",
      "@mui/icons-material/MoreHoriz"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
